'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  imageUrl: null,
  title: null,
  subtitle: null,
  templateButtons: null
}, 'Template');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/PubNubMessageMetadata/chat-rich-template/Template.js
// module id = 736
// module chunks = 2 3